<template>
    <div>
        <h1>Privacy Policy</h1>
        <p><strong>Effective Date:</strong> 2025-03-01</p>
        <p><strong>Last Updated:</strong> 2025-03-01</p>

        <section>
            <h2>1. Introduction</h2>
            <p>Welcome to <strong>Reeflendar</strong>. Your privacy is important to us, and this Privacy Policy explains how we collect, use, store, and protect your information when you use our website <strong>Reeflendar.com</strong> (the “Service”).</p>
        </section>

        <section>
            <h2>2. Information We Collect</h2>
            <h3>2.1 Information You Provide</h3>
            <ul>
                <li><strong>Account Information:</strong> When you sign up, we collect your name, email address, and authentication details (Google OAuth if used).</li>
                <li><strong>Aquarium Data:</strong> When using the platform, you may enter water parameters, notes, images, and logs related to your aquarium.</li>
                <li><strong>Customer Support:</strong> If you contact us, we collect your email and message content to assist you.</li>
            </ul>

            <h3>2.2 Information We Collect Automatically</h3>
            <ul>
                <li><strong>Usage Data:</strong> We collect device information, IP addresses, and interaction data to improve performance.</li>
                <li><strong>Cookies & Analytics:</strong> We use cookies and tracking technologies (Google Analytics) to understand how users interact with the Service.</li>
            </ul>
        </section>

        <section>
            <h2>3. How We Use Your Information</h2>
            <p>We use your information for the following purposes:</p>
            <ul>
                <li>To create and manage user accounts.</li>
                <li>To store and display aquarium logs, notes, and images.</li>
                <li>To analyze trends and improve Reeflendar’s features.</li>
                <li>To provide customer support and respond to inquiries.</li>
                <li>To ensure platform security and prevent fraud.</li>
                <li>To comply with legal obligations.</li>
            </ul>
        </section>

        <section>
            <h2>4. Data Sharing & Third-Party Services</h2>
            <p>We do <strong>not sell</strong> your personal data. However, we may share information in the following cases:</p>
            <ul>
                <li><strong>With Third-Party Services:</strong> We use Google OAuth (for authentication) and Stripe (for payments).</li>
                <li><strong>Legal Compliance:</strong> If required by law, we may share data with regulatory authorities.</li>
                <li><strong>Business Transfers:</strong> If Reeflendar is acquired, user data may be part of the transfer.</li>
            </ul>
        </section>

        <section>
            <h2>5. Data Security</h2>
            <p>We take reasonable steps to protect your data, including:</p>
            <ul>
                <li>Encryption of sensitive information.</li>
                <li>Secure access controls and authentication methods.</li>
                <li>Regular security audits and monitoring.</li>
            </ul>
            <p><strong>Note:</strong> While we implement strong security measures, no system is 100% secure. Always protect your login credentials.</p>
        </section>

        <section>
            <h2>6. Your Privacy Rights</h2>
            <p>Depending on your location, you may have the right to:</p>
            <ul>
                <li>Access and download your stored data.</li>
                <li>Request data deletion (excluding required legal data retention).</li>
                <li>Opt out of marketing communications.</li>
                <li>Disable tracking cookies (via browser settings).</li>
            </ul>
        </section>

        <section>
            <h2>7. Cookies & Tracking</h2>
            <p>We use cookies to improve user experience. You can manage cookies in your browser settings.</p>
        </section>

        <section>
            <h2>8. Third-Party Links</h2>
            <p>Reeflendar may contain links to external sites. We are not responsible for their privacy practices.</p>
        </section>

        <section>
            <h2>9. Updates to This Privacy Policy</h2>
            <p>We may update this policy periodically. We encourage users to review this page for changes.</p>
        </section>

        <section>
            <h2>10. Contact Us</h2>
            <p>If you have questions or concerns, contact us:</p>
            <ul>
                <li><strong>Email:</strong> <a href="mailto:info@reeflendar.com">info@reeflendar.com</a></li>
                <li><strong>Business Address:</strong> 2863 95th St #123 Box 175, Naperville, IL 60564</li>
                <li><strong>Support Hours:</strong> Monday - Friday, 9 AM - 5 PM (CST)</li>
            </ul>
        </section>
    </div>
</template>

<script>
import { useHead } from '@vueuse/head';

export default {
    name: 'Privacy',
    setup() {
        useHead({
            title: 'Reeflendar.com - Privacy Policy',
            meta: [
                { name: 'description', content: 'Privacy policy for Reeflendar.' },
                { name: 'keywords', content: 'privacy, policy, aquarium' },
            ],
        });
    },
}
</script>

